/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { NotificaPushBroadcastForm } from '../model/notifica-push-broadcast-form';
// @ts-ignore
import { NotificaPushDestinatariDTO } from '../model/notifica-push-destinatari-dto';
// @ts-ignore
import { NotificaPushSelezioneForm } from '../model/notifica-push-selezione-form';
// @ts-ignore
import { NotificaPushUtenteForm } from '../model/notifica-push-utente-form';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelNotificaPushInvioDTO } from '../model/paged-model-notifica-push-invio-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    NotifichePushInvioSUPERADMINServiceInterface,
    ContaDestinatariNotificaPushRequestParams,
    GetStoricoNotifichePushRequestParams,
    InviaNotificaPushBroadcastRequestParams,
    InviaNotificaPushSelezioneRequestParams,
    InviaNotificaPushUtenteRequestParams
} from './notifiche-push-invio-superadmin.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class NotifichePushInvioSUPERADMINService extends BaseService implements NotifichePushInvioSUPERADMINServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Conta i destinatari di un invio, senza inviare (SUPERADMIN)
     * Restituisce il numero di dispositivi che un invio raggiungerebbe. Da chiamare prima di confermare l\&#39;invio: e\&#39; irreversibile.  I due filtri sono mutuamente esclusivi e selezionano il tipo di anteprima: - &#x60;user_id&#x60;: dispositivi del singolo cittadino indicato. Uno zero significa che non ha mai installato l\&#39;app o ha disattivato le notifiche. - &#x60;comune_id&#x60; (o nessun filtro): anteprima di un invio globale. Il filtro seleziona i cittadini con almeno una pratica su un bando di quel Comune, NON i residenti: un cittadino registrato che non ha mai presentato domanda non appartiene ad alcun Comune ed e\&#39; raggiungibile solo omettendo il filtro.  Passati entrambi, &#x60;user_id&#x60; vince: e\&#39; una difesa contro un client malformato, non un doppio filtro componibile.  Risposte: - 200: &#x60;NotificaPushDestinatariDTO&#x60;. - 403: caller non SUPERADMIN. - 404: Comune o cittadino indicati non trovati.
     * @endpoint get /api/v1/gestione/notifiche-push/destinatari
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public contaDestinatariNotificaPush(requestParameters?: ContaDestinatariNotificaPushRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<NotificaPushDestinatariDTO>;
    public contaDestinatariNotificaPush(requestParameters?: ContaDestinatariNotificaPushRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<NotificaPushDestinatariDTO>>;
    public contaDestinatariNotificaPush(requestParameters?: ContaDestinatariNotificaPushRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<NotificaPushDestinatariDTO>>;
    public contaDestinatariNotificaPush(requestParameters?: ContaDestinatariNotificaPushRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const comuneId = requestParameters?.comuneId;
        const userId = requestParameters?.userId;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'comune_id',
            <any>comuneId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'user_id',
            <any>userId,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/notifiche-push/destinatari`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<NotificaPushDestinatariDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Storico degli invii di notifiche push (SUPERADMIN, OP_COMUNE)
     * Pagina dello storico, piu\&#39; recenti prima. Un SUPERADMIN vede tutti gli invii; un OP_COMUNE solo gli invii a selezione (&#x60;destinatario_tipo&#x3D;SELEZIONE&#x60;) con &#x60;comune_id&#x60; fra i propri comuni gestiti, anche se lanciati da un collega: i broadcast della piattaforma non compaiono, e il mittente e\&#39; indicato solo da &#x60;mittente_nome&#x60; (mai dall\&#39;email). Ogni riga porta lo stato dell\&#39;invio e i contatori (destinatari, inviati, falliti, token rimossi): &#x60;inviati&#x3D;0&#x60; su molti destinatari indica un fallimento massivo, tipicamente credenziali Firebase non valide.  Risposte: - 200: &#x60;Page&lt;NotificaPushInvioDTO&gt;&#x60;. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE.
     * @endpoint get /api/v1/gestione/notifiche-push
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getStoricoNotifichePush(requestParameters: GetStoricoNotifichePushRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelNotificaPushInvioDTO>;
    public getStoricoNotifichePush(requestParameters: GetStoricoNotifichePushRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelNotificaPushInvioDTO>>;
    public getStoricoNotifichePush(requestParameters: GetStoricoNotifichePushRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelNotificaPushInvioDTO>>;
    public getStoricoNotifichePush(requestParameters: GetStoricoNotifichePushRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getStoricoNotifichePush.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/notifiche-push`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelNotificaPushInvioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Invia una notifica push a tutti i cittadini (SUPERADMIN)
     * Avvia l\&#39;invio verso tutti i cittadini con almeno un token registrato, opzionalmente ristretti a un Comune. L\&#39;invio e\&#39; asincrono e IRREVERSIBILE: chiamare prima &#x60;GET /destinatari&#x60; per sapere quanti dispositivi verranno raggiunti.  Semantica del filtro &#x60;comune_id&#x60;: vedi &#x60;GET /destinatari&#x60;.  Risposte: - 202: invio accettato; il body porta &#x60;invio_id&#x60; da consultare nello storico. - 400: payload invalido (titolo o messaggio vuoti). - 403: caller non SUPERADMIN. - 404: Comune indicato non trovato.
     * @endpoint post /api/v1/gestione/notifiche-push/broadcast
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public inviaNotificaPushBroadcast(requestParameters: InviaNotificaPushBroadcastRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<{ [key: string]: string; }>;
    public inviaNotificaPushBroadcast(requestParameters: InviaNotificaPushBroadcastRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<{ [key: string]: string; }>>;
    public inviaNotificaPushBroadcast(requestParameters: InviaNotificaPushBroadcastRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<{ [key: string]: string; }>>;
    public inviaNotificaPushBroadcast(requestParameters: InviaNotificaPushBroadcastRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const notificaPushBroadcastForm = requestParameters?.notificaPushBroadcastForm;
        if (notificaPushBroadcastForm === null || notificaPushBroadcastForm === undefined) {
            throw new Error('Required parameter notificaPushBroadcastForm was null or undefined when calling inviaNotificaPushBroadcast.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/notifiche-push/broadcast`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<{ [key: string]: string; }>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: notificaPushBroadcastForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Invia una notifica push a una selezione di cittadini (SUPERADMIN, OP_COMUNE)
     * Avvia l\&#39;invio verso tutti i dispositivi dei cittadini indicati (da 1 a 50 id distinti; i duplicati sono ridotti a uno prima del controllo del tetto). L\&#39;invio e\&#39; asincrono: la risposta conferma la presa in carico, non il recapito.  Perimetro: i destinatari devono essere cittadini non anonimizzati ne\&#39; bloccati. Per un OP_COMUNE devono inoltre avere almeno una pratica su un bando del comune di perimetro (&#x60;comune_id&#x60;: obbligatorio se ne gestisce piu\&#39; di uno, default se ne gestisce uno solo). Per un SUPERADMIN &#x60;comune_id&#x60; e\&#39; opzionale e, se presente, applica lo stesso vincolo.  Risposte: - 202: invio accettato; il body porta &#x60;invio_id&#x60; da consultare nello storico. - 400: payload invalido, elenco vuoto o oltre 50 id distinti, &#x60;comune_id&#x60; mancante per un OP_COMUNE con piu\&#39; comuni. - 403: caller ne\&#39; SUPERADMIN ne\&#39; OP_COMUNE. - 404: comune fuori perimetro, oppure almeno un cittadino non idoneo o fuori perimetro (l\&#39;intera richiesta e\&#39; rifiutata, senza indicare quale id).
     * @endpoint post /api/v1/gestione/notifiche-push/selezione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public inviaNotificaPushSelezione(requestParameters: InviaNotificaPushSelezioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<{ [key: string]: string; }>;
    public inviaNotificaPushSelezione(requestParameters: InviaNotificaPushSelezioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<{ [key: string]: string; }>>;
    public inviaNotificaPushSelezione(requestParameters: InviaNotificaPushSelezioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<{ [key: string]: string; }>>;
    public inviaNotificaPushSelezione(requestParameters: InviaNotificaPushSelezioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const notificaPushSelezioneForm = requestParameters?.notificaPushSelezioneForm;
        if (notificaPushSelezioneForm === null || notificaPushSelezioneForm === undefined) {
            throw new Error('Required parameter notificaPushSelezioneForm was null or undefined when calling inviaNotificaPushSelezione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/notifiche-push/selezione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<{ [key: string]: string; }>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: notificaPushSelezioneForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Invia una notifica push a un singolo cittadino (SUPERADMIN)
     * Avvia l\&#39;invio verso tutti i dispositivi su cui il cittadino indicato ha registrato un token. L\&#39;invio e\&#39; asincrono: la risposta conferma la presa in carico, non il recapito.  Risposte: - 202: invio accettato; il body porta &#x60;invio_id&#x60; da consultare nello storico. - 400: payload invalido (titolo o messaggio vuoti). - 403: caller non SUPERADMIN. - 404: utente destinatario non trovato.
     * @endpoint post /api/v1/gestione/notifiche-push/utente
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public inviaNotificaPushUtente(requestParameters: InviaNotificaPushUtenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<{ [key: string]: string; }>;
    public inviaNotificaPushUtente(requestParameters: InviaNotificaPushUtenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<{ [key: string]: string; }>>;
    public inviaNotificaPushUtente(requestParameters: InviaNotificaPushUtenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<{ [key: string]: string; }>>;
    public inviaNotificaPushUtente(requestParameters: InviaNotificaPushUtenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const notificaPushUtenteForm = requestParameters?.notificaPushUtenteForm;
        if (notificaPushUtenteForm === null || notificaPushUtenteForm === undefined) {
            throw new Error('Required parameter notificaPushUtenteForm was null or undefined when calling inviaNotificaPushUtente.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/notifiche-push/utente`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<{ [key: string]: string; }>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: notificaPushUtenteForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
